import React, { useState } from 'react'
import { Item } from '../../../common/snippets'
import { AcountingHeading } from '../common/AcountingHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import { focusElemnt, navigation3 } from '../../../common/helper'
import BranchwiseCollectionAndDispatchMemoCollectionTable from './BranchwiseCollectionAndDispatchMemoCollectionTable'
import useToken from '../../../helpers/useTokens'
import { useAtom, useSetAtom } from 'jotai'
import { API_CACHE_DURATION, SELECT, urls } from '../../../common/constants'
import { GetRequest, GetRequestCachedV3 } from '../../../common/api'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { showReportAtom } from './atoms'
import { viewColumns, getBranchCollectionData } from './constants'
import { useSearchParams } from 'react-router-dom'
import { CargoRoleRightsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'

const reportName = 'Branch Wise & Dispatch Memo Collection'

const BranchwiseCollectionAndDispatchMemoCollection = () => {
  const [, setAlert] = useAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const [showReport, setShowReport] = useAtom(showReportAtom)
  const [sourceCityData, setSourceCityData] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [sourceBranchData, setSourceBranchData] = useState([])
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [sourceCity, setSourceCity] = useState({})
  const [sourceBranch, setSourceBranch] = useState({})
  const [tableData, setTableData] = useState([])
  
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, RoleName } = { ...roleRightsData }
  const [searchParams] = useSearchParams()

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    AllowViewAllBranchOfCityReport = +searchParams.get('AllowViewAllBranchOfCityReport') || 0
    AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
    isFromUrl = true
  }

  const { intCompanyID, intBranchID, intBranchCityID, strCompanyName } = loginData

  const headerData = [
    {
      company: strCompanyName,
      city: sourceCity?.CityName,
      branch: sourceBranch?.BranchName,
    },
  ]
  const selectedSourceCity = (obj) => {
    setShowReport(false)
    setSourceCity(obj)
    if (obj.CityID === 0) {
      setSourceBranchData([{ BranchID: 0, BranchName: 'All' }, ...sourceBranchList])
      setSourceBranch({ BranchID: 0, BranchName: 'All' })
    } else {
      const filterSourceBranchData = sourceBranchList.filter((item) => item.cityid === obj.CityID)
      setSourceBranchData([{ BranchID: 0, BranchName: 'All' }, ...filterSourceBranchData])
      setSourceBranch({ BranchID: 0, BranchName: 'All' })
    }

  }
  const selectedSourceBranch = (obj) => {
    setShowReport(false)
    setSourceBranch(obj)
  }
  const getBranches = async () => {
    const data = {
      CompanyID: intCompanyID
    }
    const res = await GetRequestCachedV3(urls.getCollectionBranchList, data, true, API_CACHE_DURATION)
    if (res.status === 'Success') {
      const sourceCityData = res?.Data?.Table || []
      setSourceCityData([{ CityID: 0, CityName: 'All' }, ...sourceCityData])
      const ownCity = sourceCityData.find((item) => item.CityID === intBranchCityID)
      if (ownCity) {
        setSourceCity(ownCity)
        const sourceBranchData = res?.Data?.Table1 || []
        setSourceBranchList(sourceBranchData)
        const ownCityBranches = sourceBranchData.filter((item) => item.cityid === ownCity.CityID)
        setSourceBranchData(ownCityBranches)
        const ownBranch = sourceBranchData.find((item) => item.BranchID === intBranchID) || {}
        setSourceBranch(ownBranch)
      }
    } else {
      setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
    }
  }
  const getBranchCollection = async (isPdf = false) => {
    if (Object.keys(sourceBranch.BranchID).length < 0) {
      setAlert({ show: true, msg: 'Please Select Branch', nextId: '' })
      return
    }
    const body = {
      CompanyID: intCompanyID,
      BranchID: sourceBranch.BranchID,
      FromDate: moment(fromDate).format('YYYY-MM-DD'),
      ToDate: moment(toDate).format('YYYY-MM-DD'),
      CityID: sourceCity.CityID,
    }
    setLoader(true)
    const reportData = await getBranchCollectionData(body, setAlert)
    setLoader(false)
    if (!reportData) return
    const reportPayload = {
      id: 'branch_wise_and_dispatch_memo',
      tableData: reportData,
      reportName: reportName,
      roleName: RoleName,
      filterData: {
        sourceCity,
        sourceBranch,
      },
      headerData: headerData,
      saveMeta: body,
    }

    if (isPdf === true) {
        const filteredViewColumns = viewColumns.filter(col => col.field !== 'Action')

        const pdfCriteriaHeaders = [
          { header: 'Company', field: 'Company', xlCol: { dataType: 'string' } },
          { header: 'City', field: 'City', xlCol: { dataType: 'string' } },
          { header: 'Branch', field: 'Branch', xlCol: { dataType: 'string' } },
        ]
        const pdfCriteriaData = [{
          Company: strCompanyName || '',
          City: sourceCity?.CityName || '',
          Branch: sourceBranch?.BranchName || '',
          dataType: 'entry',
        }]

        const totals = reportData.reduce((acc, curr) => {
          acc.BusCollectionAmt += Number(curr.BusCollectionAmt) || 0
          acc.CargoCollectionAmt += Number(curr.CargoCollectionAmt) || 0
          acc.ClosingBalance += Number(curr.ClosingBalance) || 0
          acc.OldReceivedAmt += Number(curr.OldReceivedAmt) || 0
          acc.OldReceivedBankAmt += Number(curr.OldReceivedBankAmt) || 0
          acc.OpeningBalance += Number(curr.OpeningBalance) || 0
          acc.ReceivedAmt += Number(curr.ReceivedAmt) || 0
          acc.ReceivedBankAmt += Number(curr.ReceivedBankAmt) || 0
          acc.openingblnc += Number(curr.openingblnc) || 0
          acc.TotalAmount += Number(curr.TotalAmount) || 0
          return acc
        }, {
          BusCollectionAmt: 0, CargoCollectionAmt: 0, ClosingBalance: 0,
          OldReceivedAmt: 0, OldReceivedBankAmt: 0, OpeningBalance: 0,
          ReceivedAmt: 0, ReceivedBankAmt: 0, openingblnc: 0, TotalAmount: 0,
        })

        const formattedTotals = Object.fromEntries(
          Object.entries(totals).map(([key, value]) => [key, value.toFixed(2)])
        )

        const reportDataWithTotal = [
          ...reportData,
          { ...formattedTotals, isTotal: true, sn: 'Total', dataType: 'total', colSpan: { 'sn': 3 } }
        ]

        const visibleColumns = filteredViewColumns.map(col => ({
          ...col,
          exportHead: col.exportHead || col.headerName,
          xlCol: col.xlCol || { dataType: 'string' },
          weight: 80,
        }))

        downloadPDF({
          reportName,
          criteriaHeaders: pdfCriteriaHeaders,
          criteriaData: pdfCriteriaData,
          tableData: reportDataWithTotal,
          visibleColumns,
          loginData,
          hideHeader: false,
        })
        return
      }
      const rid = Date.now().toString()

      if (!window.generatedReports) {
        window.generatedReports = {}
      }

      window.generatedReports[rid] = reportPayload

      window.open(`/view-reportV2?rid=${rid}`, "_blank")
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <AcountingHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px', ...(!isFromUrl && { flexWrap: 'wrap' }) }}>
          {!isFromUrl && <>
            <Item sx={sx.itemsx}>
              <DropDownOA
                id={'selectCompany'}
                label={'Select Company'}
                onSelect={(val) => {
                }}
                nextId={'goButton'}
                prevId={''}
                defaultvalue={strCompanyName}
                disabled={true}
                width="100%"
              />
            </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button
                variant="contained"
                style={{ ...sx.fullHeight, ...sx.novp }}
                id={'goButton'}
                className="btn btn-primary"
                onKeyDown={(e) => navigation3(e, 'fromDate', 'selectCompany', () => { })}
                onClick={getBranches}
              >
                GO
              </Button>
            </Item>
          </>}
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker" style={!isFromUrl ? { zIndex: '3' } : {}}>
            <Datepicker
              label={`Select From Date`}
              name={'from_date'}
              id={'fromDate'}
              nextId={'toDate'}
              prevId={'goButton'}
              value={fromDate}
              maxDate={toDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('SelectCity')
              }}
              width="100%"
            />
          </Item>
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '10px', width: isFromUrl ? '100%' : 'auto' }}>
            <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker" style={!isFromUrl ? { zIndex: '3' } : {}}>
              <Datepicker
                label={`Select To Date`}
                name={'to_date'}
                id={'toDate'}
                nextId={'SelectCity'}
                prevId={'fromDate'}
                value={toDate}
                minDate={fromDate}
                dateChange={(date) => {
                  setToDate(date)
                  focusElemnt('SelectCity')
                }}
                width="100%"
              />
            </Item>
            {isFromUrl && <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button
                variant="contained"
                style={{ ...sx.fullHeight, ...sx.novp }}
                id={'goButton'}
                className="btn btn-primary"
                onKeyDown={(e) => navigation3(e, 'fromDate', 'selectCompany', () => { })}
                onClick={getBranches}
              >
                GO
              </Button>
            </Item>}
          </Box>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={'SelectCity'}
              label={'Select City'}
              nextId={'SelectBranch'}
              prevId={'toDate'}
              data={sourceCityData}
              defaultvalue={sourceCity?.CityName || SELECT}
              dataKey={`CityName`}
              idKey={`CityID`}
              onSelect={(obj) => selectedSourceCity(obj)}
              searchPlaceholder={`Select City`}
              width="100%"
              disabled={AllowViewAllBranchReport === 0 || AllowViewAllBranchOfCityReport === 0}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={'SelectBranch'}
              label={'Select Branch'}
              nextId={'generateButton'}
              prevId={'SelectCity'}
              data={sourceBranchData}
              defaultvalue={sourceBranch?.BranchName || SELECT}
              dataKey={`BranchName`}
              idKey={`BranchID`}
              onSelect={(val) => selectedSourceBranch(val)}
              isObjArr={true}
              searchPlaceholder={`Select Branch`}
              width={isFromUrl ? '100%' : '350px'}
              disabled={AllowViewAllBranchReport === 0 && AllowViewAllBranchOfCityReport === 0}
            />
          </Item>
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => getBranchCollection(true)} id={'generateButton'}>
              DOWNLOAD PDF
            </Button> :
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button
                variant="contained"
                style={{ ...sx.fullHeight, ...sx.novp }}
                id={'generateButton'}
                className="btn btn-primary"
                onClick={getBranchCollection}
                onKeyDown={(e) => navigation3(e, 'fromDate', 'SelectBranch', () => { })}
              >
                GENERATE
              </Button>
            </Item>}
        </Box>
      </Item>
      <Box>
        {showReport ? (
          <BranchwiseCollectionAndDispatchMemoCollectionTable
            sourceCity={sourceCity}
            sourceBranch={sourceBranch}
            headerData={headerData}
            tableData={tableData}
            reportName={reportName}
            setTableData={setTableData}
            roleName={RoleName}
          />
        ) : (
          ''
        )}
      </Box>
    </>
  )
}
export default BranchwiseCollectionAndDispatchMemoCollection
